import { LANG_ENG, ENDPOINT_NEWS_ENG, ENDPOINT_NEWS_SV } from '../../constants/strings';


const InternalHyperLinks = [
  {
    "text": "LLM",
    "translation": "[LLM]",
    "id": "g0cSE4J3Jy"
  },

  {
    "text": "Gemini",
    "translation": "[Gemini]",
    "id": "rgbI9RMVdF"
  },
  {
    "text": "AI-agenter",
    "translation": "[AI-agenter]",
    "id": "AKfGaabrUb"
  },
  {
    "text": "Custom GPT",
    "translation": "[Custom GPT]",
    "id": "zMSm9aRGjk"
  },
  {
    "text": "Chatbot",
    "translation": "[Chatbot](/chatbot)",
    "id": "chatbot",
    "isDirectLink": true
  },
  {
    "text": "Claude",
    "translation": "[Claude]",
    "id": "claude",
    "isDirectLink": true
  },
  {
    "text": "Claude Cowork",
    "translation": "[Claude cowork]",
    "id": "16FGJjKLlB",
  },
  {
    "text": "Claude Code",
    "translation": "[Claude code]",
    "id": "A1B2C3D4E5",
  },
  {
    "text": "Claude Design",
    "translation": "[Claude design]",
    "id": "XpLmNqRds",
  }

]

const addHyperLinks = (text, language) => {
  InternalHyperLinks.forEach(link => {
    if (text.includes(link.text)) {
      if (link.isDirectLink) {
        text = text.replaceAll(link.text, link.translation);
      } else {
        text = text.replaceAll(link.text, link.translation + newsEndPoint(link, language));
      }
    }
  });
  return text;
}

const newsEndPoint = (link, language, isDirectLink) => {
  if (isDirectLink) {
    return "(" + "/" + link.id + ")"
  }
  return "(" + (language === LANG_ENG ? ENDPOINT_NEWS_ENG : ENDPOINT_NEWS_SV) + "/" + link.id + ")"
}

const addNewsHyperLinks = (text, currentNews, language) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');

  // Get all text nodes that are not within h1-h4 or a tags
  const walker = document.createTreeWalker(
    doc.body,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode: (node) => {
        // Check all parent elements up to the root
        let currentParent = node.parentElement;
        while (currentParent) {
          if (currentParent.matches('h1, h2, h3, h4, a')) {
            return NodeFilter.FILTER_REJECT;
          }
          currentParent = currentParent.parentElement;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    }
  );

  let modifiedText = text;
  const textNodes = [];
  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  InternalHyperLinks.forEach(link => {
    if (link.id === currentNews.id) return;
    for (const node of textNodes) {
      if (!node.textContent.includes(link.text)) continue;
      const newText = node.textContent.replace(
        link.text,
        link.translation + newsEndPoint(link, language, link.isDirectLink)
      );
      modifiedText = modifiedText.replace(node.textContent, newText);
      break; // at most one insertion per link object
    }
  });

  return modifiedText;
}

export { InternalHyperLinks, addHyperLinks, addNewsHyperLinks };  